import dayjs from "dayjs"
import _ from "lodash"
import { AppDispatch } from "../../.."
import {
  showInfoToast,
  showWarningToast,
} from "../../../components/CustomToast"
import {
  e請求支払確認区分,
  e配車状態区分,
  T配車状態区分値,
} from "../../../constant/enum/zyutuHaisya"
import { setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import HaisyaService from "../../../service/order/haisya/HaisyaService"
import {
  THaisyaListGetReq,
  T車輌乗務員,
  T配車,
} from "../../../service/order/haisya/THaisya"
import { TZyutyuHaisyaListGetRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"

// export const DEFAULT_CARD_CLASS = "tumibi-zyutyu-haisya-card rounded"
export const DEFAULT_CARD_CLASS = "tumibi-zyutyu-haisya-card"

/**
 * 当日卸日のデータを集める（運行分割以外）
 * @param 車輌乗務員
 * @param 当日
 * @returns
 */
export const 当日卸配車取得 = (車輌乗務員: T車輌乗務員, 当日: string) =>
  車輌乗務員.受注配車.filter((h) => {
    //積日の違う運行分割以外の卸日の日付のデータを取得
    const isSame積日 = dayjs(h.積日).isSame(dayjs(当日), "date")
    const isSame卸日 = dayjs(h.卸日).isSame(dayjs(当日), "date")
    return (
      !isSame積日 &&
      isSame卸日 &&
      !車輌乗務員.分割受注配車情報.find(
        (b) => b.受注配車ID === h.受注配車ID && b.請求対象フラグ === 0
      )
    )
  })

/**
 * 当日積日および卸日のデータと卸分割の受注で当日卸日のデータを集める
 * @param 車輌乗務員
 * @param 当日
 * @returns
 */
export const 当日配車取得 = (車輌乗務員: T車輌乗務員, 当日: string) =>
  車輌乗務員.受注配車.filter((h) => {
    //運行分割の卸側を取得
    if (
      車輌乗務員.分割受注配車情報.find(
        (b) => b.受注配車ID === h.受注配車ID && b.請求対象フラグ === 0
      )
    ) {
      const isSame卸日 = dayjs(h.卸日).isSame(dayjs(当日), "date")
      return isSame卸日
    } else {
      const isSame積日 = dayjs(h.積日).isSame(dayjs(当日), "date")
      return isSame積日
    }
  })

/**
 * 配送中確認
 * @param h
 * @param 当日
 * @returns
 */
export const is配送中確認 = (h: TZyutyuHaisyaListGetRes, 当日: string) => {
  //当日の日付を挟む形で受注しており、かつ分割に存在しない受注配車を取得
  const isBefore積日 = dayjs(h.積日).isBefore(dayjs(当日), "date")
  const isAfter卸日 = dayjs(h.卸日).isAfter(dayjs(当日), "date")
  return isBefore積日 && isAfter卸日
}

/**
 * 配送中のデータを集める（運行分割以外）
 * @param 車輌乗務員
 * @param 当日
 * @returns
 */
export const 配送中配車取得 = (車輌乗務員: T車輌乗務員, 当日: string) =>
  車輌乗務員.受注配車.filter((h) => {
    //当日の日付を挟む形で受注しており、かつ分割に存在しない受注配車を取得
    return (
      is配送中確認(h, 当日) &&
      !車輌乗務員.分割受注配車情報.find((b) => b.受注配車ID === h.受注配車ID)
    )
  })

/**
 * 当日の全配車を取得
 * @param 車輌乗務員
 * @param 当日
 * @returns
 */
export const 当日全配車 = (車輌乗務員: T車輌乗務員, 当日: string) => {
  // 当日積日のデータと卸分割の受注で当日卸日のデータを集める
  const 積日当日配車 = 当日配車取得(車輌乗務員, 当日)
  const 過去日積当日卸配車 = 当日卸配車取得(車輌乗務員, 当日)
  const 配送中受注配車 = 配送中配車取得(車輌乗務員, 当日)
  // 配送中 ⇒ 当日卸日 ⇒ 当日積日の順で表示する
  // orderBy用関数
  const orderBy: (keyof TZyutyuHaisyaListGetRes)[] = [
    "積日",
    "配送順",
    "卸日",
    "受注伝票番号",
    "受注枝番",
  ]

  const 当日配車 = [
    ..._.orderBy(配送中受注配車, orderBy),
    ..._.orderBy(過去日積当日卸配車, orderBy),
    ..._.orderBy(積日当日配車, orderBy),
  ]

  return 当日配車
}

export const e運行分割 = {
  積側: 1,
  卸側: 2,
} as const

export type T運行分割名称 = keyof typeof e運行分割
export type T運行分割 = (typeof e運行分割)[T運行分割名称]

/**
 * 運行分割卸側判定
 * @param 車輌乗務員
 * @param 配車
 * @returns
 */
export const check運行分割 = (
  車輌乗務員: T車輌乗務員,
  配車: TZyutyuHaisyaListGetRes
) => {
  const 分割情報 = 車輌乗務員.分割受注配車情報.find(
    (b) => b.受注配車ID === 配車.受注配車ID
  )

  switch (分割情報?.請求対象フラグ) {
    case 0:
      return e運行分割.卸側
    case 1:
      return e運行分割.積側
    default:
      return null
  }
}

export const set配送順 = async (props: {
  dispatch: AppDispatch
  配車: T配車
  乗務員: T車輌乗務員
  積日: string
  配送順: number
  searchCondition: THaisyaListGetReq
  set車輌乗務員List: (v: T車輌乗務員[]) => unknown
  set未配車List: (v: T配車[]) => unknown
}) => {
  const 配車状態区分 = props.配車.配車状態区分コード as T配車状態区分値
  // 配車状態がe配車状態区分.乗務員連絡済・e配車状態区分.キャンセルのとき、移動不可
  if (
    配車状態区分 === e配車状態区分.乗務員連絡済 ||
    配車状態区分 === e配車状態区分.キャンセル ||
    配車状態区分 === e配車状態区分.その他請求
  ) {
    return false
  }
  const セル積日 = dayjs(props.積日)
  const 配車積日 = dayjs(props.配車.積日)
  // 積日の違う配車は登録できないようにする。
  if (!セル積日.isSame(配車積日, "d")) {
    showWarningToast("積日に相違があるため登録できません。")
    return false
  }

  // 請求額確認済のときは処理完了済のため動かせないようにする
  const 請求額確認区分 = props.配車.請求額確認区分コード
  if (請求額確認区分 === e請求支払確認区分.確認済) {
    return false
  }
  const 受注配車ID = props.配車.受注配車ID
  props.dispatch(画面ロック開始())
  try {
    const service = new HaisyaService()
    const res = await service.putHaisoZyun(受注配車ID, {
      乗務員コード: props.乗務員.乗務員コード,
      車輌ID: props.乗務員.車輌ID,
      トレーラ車輌ID: props.乗務員.トレーラ車輌ID,
      積日: props.積日,
      配送順: props.配送順,
      更新日時: props.配車.更新日時!,
    })
    // 登録に成功した場合、再検索し画面を更新する
    if (res) {
      props.dispatch(setAlerts(res))
      if (res.data) {
        showInfoToast("受注配車情報を更新しました。")
      }
      return true
    }
    return false
  } catch (error) {
    props.dispatch(setAlerts(error))
  } finally {
    props.dispatch(画面ロック解除())
  }
}

/**
 * 表示用クラス設定と配送中であるかの判断を返します
 * @param 車輌乗務員
 * @param 配車
 * @param 基準日
 * @returns [クラス名:string, 配送中フラグ:boolean]
 */
export const set配車CardClass = (
  車輌乗務員: T車輌乗務員,
  配車: TZyutyuHaisyaListGetRes,
  基準日: string
): [string, boolean] => {
  // 表示用のクラス設定 優先度は 分割判定 > 積卸判定 > 乗務員変更
  const 運行分割判定 = check運行分割(車輌乗務員, 配車)
  let 配送中フラグ = false
  let className = ""
  switch (運行分割判定) {
    case e運行分割.卸側:
      className = "child-bunkatu"
      break
    case e運行分割.積側:
      className = "parent-bunkatu"
      break
    default:
      // 積日のみのカードもしくは卸日のみのカードの場合色を変える
      const isSame積日 = dayjs(配車.積日).isSame(dayjs(基準日), "date")
      const isSame卸日 = dayjs(配車.卸日).isSame(dayjs(基準日), "date")
      if (isSame積日 && !isSame卸日) {
        className = "tumi-only"
      } else if (!isSame積日 && isSame卸日) {
        className = "orosi-only"
      } else if (is配送中確認(配車, 基準日)) {
        //配送中のカードのため卸のカードの色にした上で配車中表示をする
        className = "orosi-only"
        配送中フラグ = true
      } else {
        // 配車の乗務員が違う場合色を変える
        if (配車.乗務員ID !== 車輌乗務員.乗務員ID) {
          className = "zyomuin-change"
        }
      }
      break
  }
  return [className, 配送中フラグ]
}
